'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp2; /* eslint-disable react/no-danger */

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _antd = require('@adparlor-devops/antd');

var _reactIntl = require('react-intl');

var _isEmpty = require('lodash/lang/isEmpty');

var _isEmpty2 = _interopRequireDefault(_isEmpty);

var _helpers = require('../../../helpers');

var _constants = require('../../../constants');

require('./ActivityTableChild.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ActivityTableChild = (_temp2 = _class = function (_Component) {
  (0, _inherits3.default)(ActivityTableChild, _Component);

  function ActivityTableChild() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, ActivityTableChild);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = ActivityTableChild.__proto__ || (0, _getPrototypeOf2.default)(ActivityTableChild)).call.apply(_ref, [this].concat(args))), _this), _this.determineColumn = function (origin) {
      switch (origin) {
        case _constants.RIPPLE_FACEBOOK_PLATFORM:
          return ActivityTableChild.DEFAULT_COLUMNS;
        case _constants.MONEYTALK_FACEBOOK_PLATFORM:
        case _constants.THUMBSUP_FACEBOOK_PLATFORM:
          return ActivityTableChild.IMPORT_COLUMNS;
        default:
          return [];
      }
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(ActivityTableChild, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          events = _props.events,
          origin = _props.origin;

      var columns = this.determineColumn(origin);

      return _react2.default.createElement(
        'div',
        { className: 'ActivityTableChild__Component' },
        _react2.default.createElement(_antd.Table, {
          rowKey: 'id',
          size: 'default',
          columns: columns,
          loading: (0, _isEmpty2.default)(events),
          dataSource: events,
          pagination: {
            size: "small",
            defaultPageSize: 15
          }
        })
      );
    }
  }]);
  return ActivityTableChild;
}(_react.Component), _class.propTypes = {
  events: _propTypes2.default.arrayOf(_propTypes2.default.object),
  origin: _propTypes2.default.string.isRequired
}, _class.defaultProps = {
  events: []
}, _class.DEFAULT_COLUMNS = [{
  title: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'ActivityTableChild.table.entity.column', defaultMessage: 'Entity' }),
  dataIndex: 'affectedEntity',
  key: 'affectedEntity',
  sorter: (0, _helpers.sortColumn)('affectedEntity'),
  render: function render(affectedEntity) {
    return _react2.default.createElement('div', { dangerouslySetInnerHTML: { __html: affectedEntity } });
  }
}, {
  title: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'ActivityTableChild.table.start.column', defaultMessage: 'Start' }),
  dataIndex: 'startDisplay',
  key: 'start',
  className: 'text-align-center',
  width: '100px',
  sorter: (0, _helpers.sortColumn)('start')
}, {
  title: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'ActivityTableChild.table.end.column', defaultMessage: 'End' }),
  dataIndex: 'endDisplay',
  key: 'end',
  className: 'text-align-center',
  width: '100px',
  sorter: (0, _helpers.sortColumn)('end')
}, {
  title: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'ActivityTableChild.table.result.column', defaultMessage: 'Result' }),
  dataIndex: 'resultDisplay',
  key: 'result',
  className: 'text-align-center',
  width: '100px',
  sorter: (0, _helpers.sortColumn)('result')
}], _class.IMPORT_COLUMNS = [{
  title: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'ActivityTableChild.table.entity.column', defaultMessage: 'Entity' }),
  dataIndex: 'affectedEntity',
  key: 'affectedEntity',
  sorter: (0, _helpers.sortColumn)('affectedEntity'),
  render: function render(affectedEntity) {
    return _react2.default.createElement('div', { dangerouslySetInnerHTML: { __html: affectedEntity } });
  }
}, {
  title: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'ActivityTableChild.table.result.column', defaultMessage: 'Result' }),
  dataIndex: 'resultDisplay',
  key: 'result',
  className: 'text-align-center',
  width: '100px',
  sorter: (0, _helpers.sortColumn)('result')
}], _temp2);
exports.default = ActivityTableChild;


//////////////////
// WEBPACK FOOTER
// ./~/@adparlor-devops/dear-diary/lib/modules/ActivityTable/components/ActivityTableChild.js
// module id = 3420
// module chunks = 2